<template>
  <div class="insights-ia-empty-state">
    <MaterialIcon icon="search_off" size="32px" />
    <p>{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";

defineProps<{
  description: string;
}>();
</script>

<style scoped lang="scss">
.insights-ia-empty-state {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  min-height: 350px;
  color: _map.get($map: $neutro, $key: 400);

  p {
    margin: 0;
    color: _map.get($map: $neutro, $key: 600);
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
}
</style>
